import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  popover: {
    marginTop: 4,
    marginLeft: 15
  }
}));
